module.exports = __webpack_public_path__ + "media/images/gray-youtube-2bb71619347fe55d0621f8c7c20081c6.png";